import * as React from 'react';
import { AppBar, Toolbar, IconButton, Typography } from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import clsx from 'clsx';
import { useHistory } from 'react-router-dom';

import { signOut, getAttributeUserName } from 'services/AuthService';
import { useStyles } from './styles';
import SplitMenu from './SplitMenu/SplitMenu';
import { useUserDispatch, useInfoUserDispatch } from 'context/UserContext';
import { useLayoutState, toggleSidebar, useLayoutDispatch } from 'context/LayoutContext';
import LogoCavca from 'assets/Branding/cavcaLogoV2White.png';

const Header: React.FC<IHeaderWithDrawer> = ({ drawerVisible }) => {
  const classes = useStyles();

  const history = useHistory();

  const { isSidebarOpened } = useLayoutState();
  const layoutDispatch = useLayoutDispatch();
  const userDispatch = useUserDispatch();
  const infoUserDispatch = useInfoUserDispatch();

  const [userName, setUserName] = React.useState('');

  const onSignOut = () => {
    signOut({ userDispatch, infoUserDispatch, history });
  };

  const handleDrawerOpen = () => {
    toggleSidebar(layoutDispatch);
  };

  React.useEffect(() => {
    const fetchUserName = async () => {
      const name = await getAttributeUserName();
      setUserName(name);
    };
    fetchUserName();
  }, []);

  return (
    <AppBar
      position="absolute"
      className={clsx(classes.appBar, drawerVisible && isSidebarOpened && classes.appBarShift)}>
      <Toolbar className={classes.toolbar}>
        {drawerVisible && (
          <IconButton
            edge="start"
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            className={clsx(classes.menuButton, isSidebarOpened && classes.menuButtonHidden)}>
            <MenuIcon />
          </IconButton>
        )}
        {!isSidebarOpened && <img className={classes.logo} src={LogoCavca} alt="logo" />}
        <Typography style={{ marginTop: '5px' }}>Buenos dias, {userName}</Typography>
        <div style={{ flexGrow: 1 }} />
        <SplitMenu onClick={onSignOut} />
      </Toolbar>
    </AppBar>
  );
};

export default Header;
